"use strict";

spreadsheets.filter("spreadsheetFilter", function() {
    return function( items, filter ) {
        var filtered = [];
        for (var i=0; i < items.length; i++)
        {
            var add = false;
            var item = items[i];
            if (item!=undefined) {
                if (filter.application && item.type != 2)
                    add = true;
                else if (filter.applicant && item.type == 2)
                    add = true;

                if (add)
                    filtered.push(item);
            }
        }
        return filtered;
    };
});
